import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteOrganizationMutation} from '../hooks/useOrganizationsQuery';
import {useOrganizationsSelection} from "../hooks/useOrganizationsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteOrganizationMutation = useDeleteOrganizationMutation();

    const {
        selection,
        handleClearSelection,
    } = useOrganizationsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteOrganizationMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
